import React, { Component } from 'react'
import {NavLink} from 'react-router-dom'

export default class Header extends Component {
  render() {
    return (
      <div>
      <nav className="main-header navbar navbar-expand navbar-dark">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="fake_url" role="button"><i className="fas fa-bars" /></a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            {/*!<a href="index3.html" className="nav-link">Home</a>*/}
            <NavLink to="/dashboard" className="nav-link">Home</NavLink>
            
          </li>          
        </ul>        
      </nav>

      </div>
    )
  }
}
